import React, { useState, useEffect, useContext } from 'react'
import { NavigationContext } from '../NavigationContext'

function PageContent() {
  const [content, setContent] = useState(null)
  const { currentSlug } = useContext(NavigationContext)

  useEffect(() => {
    let isMounted = true

    const fetchContent = async () => {
      try {
        const response = await fetch(`/wp-json/wp/v2/pages?slug=${currentSlug}`)
        const data = await response.json()
        
        if (isMounted && data.length > 0) {
          setContent(data[0])
        }
      } catch (error) {
        console.error('Error fetching content:', error)
      }
    }

    if (currentSlug) {
      fetchContent()
    }

    return () => {
      isMounted = false
    }
  }, [currentSlug])

  return content ? (
    <div dangerouslySetInnerHTML={{ __html: content.content.rendered }} />
  ) : null
}

export default PageContent